import * as React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppAction } from '../../../config/appConfig'
import { MenuItemKey } from '../../../components/MainMenu'
import { FileAction } from '../../../config/fileConfig'
import BasePartyOverview from './BasePartyOverview'

export default function PartyOverview() {
    const dispatch = useDispatch()

    //Reset breadcrumbs and data
    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Parties] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [])

    return <BasePartyOverview inputPlaceholderKey={'party.filter.search'} localStorageKeyPrefix={'HammockPartyOverview'} />
}
